export const variantPriorityOrder = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit",
];
export const variantProps = ["initial", ...variantPriorityOrder];
//# sourceMappingURL=variant-props.js.map